import serviceAxios from "./request";
// 字典列表
export const adList = (params) => {
	return serviceAxios({
		url: "/app/ad/list",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 基本配置
export const configBase = (params) => {
	return serviceAxios({
		url: "/app/config/base",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 文章详情
export const articledetail = (params) => {
	return serviceAxios({
		url: "/app/article/detail",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 获取邮箱验证码
export const regCaptcha = (params) => {
	return serviceAxios({
		url: "/app/authMember/regCaptchaEmail",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 帐号注册-邮箱
export const registerByEmail = (data) => {
	return serviceAxios({
		url: "/app/authMember/registerByEmail",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
// 手机号或邮箱密码登录
export const authMemberloginByPassword = (data) => {
	return serviceAxios({
		url: "/app/authMember/loginByPassword",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
// 重置密码
export const authMemberrestPassword = (data) => {
	return serviceAxios({
		url: "/app/authMember/restPassword",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
// 获取个人信息
export const authMemberInfo = (params) => {
	return serviceAxios({
		url: "/app/authMember/info",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 个人信息更新
export const authMemberInfoprofile = (data) => {
	return serviceAxios({
		url: "/app/authMember/profile",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
// 个人信息 统计
export const authMemberIndex = (params) => {
	return serviceAxios({
		url: "/app/authMember/index",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
/**********************************************/
// 唛头列表
export const memberCodeList = (params) => {
	return serviceAxios({
		url: "/app/memberCode/list",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 唛头列表 新增
export const memberCodeAdd = (data) => {
	return serviceAxios({
		url: "/app/memberCode/add",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
// 唛头列表 删除
export const memberCodeRemove = (params) => {
	return serviceAxios({
		url: "/app/memberCode/remove",
		method: "delete",
		params,
		headers:{'Content-Type':'application/x-www-form-urlencoded'}
	});
};
// 唛头列表 修改
export const memberCodeUpdate = (data) => {
	return serviceAxios({
		url: "/app/memberCode/update",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
/*************************/
// 搜索
export const packageMiniSearch = (params) => {
	return serviceAxios({
		url: "/app/packageMini/search",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 认领小包裹
export const packageMiniClaim = (params) => {
	return serviceAxios({
		url: "/app/packageMini/claim",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 批量导入小包裹
export const packageMiniBatchImport = (data) => {
	return serviceAxios({
		url: "/app/packageMini/batchImport",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
/******************/
// 我的小包裹列表
export const packageMiniList = (params) => {
	params = {
		...params,
		orderByColumn:'id',
		isAsc:'desc',
	}
	return serviceAxios({
		url: "/app/packageMini/list",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 我的小包裹列表 删除
export const packageMiniDelete = (params) => {
	return serviceAxios({
		url: "/app/packageMini/delete",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 申请打包
export const packageBigApplyPack = (data) => {
	return serviceAxios({
		url: "/app/packageBig/applyPack",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};
// 我的小包裹详情
export const packageMiniDetail = (params) => {
	return serviceAxios({
		url: "/app/packageMini/detail",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
/***********************/
// 查询大包裹列表
export const packageBigList = (params) => {
	params = {
		...params,
		orderByColumn:'id',
		isAsc:'desc',
	}
	return serviceAxios({
		url: "/app/packageBig/list",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 获取大包裹详细信息
export const packageBigDetail = (params) => {
	return serviceAxios({
		url: "/app/packageBig/detail",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 查询车次详情
export const trainDetail = (params) => {
	return serviceAxios({
		url: "/app/train/detail",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 查询列表报价单
export const quotationList = (params) => {
	return serviceAxios({
		url: "/app/quotation/list",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 申请查看详情
export const applyLookDetail = (params) => {
	return serviceAxios({
		url: "/app/packageMini/applyLookDetail",
		method: "get",
		params,
		headers:{"Content-Type":"application/json"}
	});
};
// 更新小包裹
export const packageMiniupdate = (data) => {
	return serviceAxios({
		url: "/app/packageMini/update",
		method: "post",
		data,
		headers:{"Content-Type":"application/json"}
	});
};